export const useAuth = () => {
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const permissions: string[] = user?.all_permissions || [];
  const roles: string[] = user?.roles?.map((r: any) => r.name) || [];

  const hasPermission = (perm: string): boolean => permissions.includes(perm);
  const hasRole = (role: string): boolean => roles.includes(role);

  return { user, permissions, roles, hasPermission, hasRole };
};
